import { makeStyles, Theme } from '@material-ui/core';
import { usePickerErrorsStyles } from 'styles/pickersErrorStyle'

interface StyleProps {
  limitTag?: number;
  inputSize?: string;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  ...usePickerErrorsStyles(theme),
  scroll: {
    display: 'flex',
    flexWrap: (props) => (props.limitTag === -1 ? 'wrap' : 'nowrap'),
    maxHeight: '110px',
    overflowY: 'auto',
  },
  container: {
    '& .MuiAutocomplete-root': {
      width: (props) => {
        switch (props.inputSize) {
          case 'small':
            return 350;
          case 'medium':
            return 560;
          case 'large':
            return 1016;
          case 'fullWidth':
            return '100%';
          default:
            return 350;
        }
      },
      '&.Mui-focused': {
        width: (props) => {
          switch (props.inputSize) {
            case 'small':
              return 350;
            case 'medium':
              return 560;
            case 'large':
              return 1016;
            case 'fullWidth':
              return '100%';
            default:
              return 350;
          }
        },
      },
    },
    '& span.MuiAutocomplete-tag': {
      cursor: 'pointer',
      right: 60,
      borderRadius: '50%',
      padding: 2,
      '&:hover': {
        backgroundColor: 'rgba(0, 141, 155, 0.12)',
      },
    },
    '& .MuiInputBase-root': {
      display: 'flex',
      flexWrap: 'nowrap',
    },
    '& .MuiChip-root': {
      overflow: 'hidden',
      flex: '0 1 auto',
      backgroundColor: theme.palette.fill.tertiary,
      color: theme.palette.text.primary,
      ...theme.typography.subtitle1,
      '& .MuiChip-deleteIcon': {
        color: theme.palette.text.primary,
      },
    },
    '& .MuiInputBase-root.Mui-focused': {
      zIndex: '2',
      flexWrap: 'wrap',
      '& $scroll': {
        flexWrap: 'wrap',
      },
    },
    '& .MuiFormLabel-root.Mui-focused': {
      zIndex: '3',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]':
      {
        padding: theme.spacing(0, 8, 0, 0.75),
      },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] .MuiAutocomplete-input':
      {
        padding: theme.spacing(1.3125, 0.5),
      },
  },
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: 'transparent',
    },
    '&[data-focus="true"]': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .MuiCheckbox-root': {
      marginRight: 8,
      color: '#757575',
    },
  },
  listbox: {
    maxHeight: 484,
  },
  tagSizeSmall:{
    margin:'2px',
    maxWidth:'calc(100% - 4px)'
  },
  errorBorder:{
    '& .MuiOutlinedInput-root fieldset':{
      borderColor:`${theme.palette.error.main} !important`,
    },
  }
}));
